class InitialDataManagerService {
  constructor(AuthenticationService, ManagerDataService, vacationManagerRepositoryService) {
    'ngInject';
    this.managerId = AuthenticationService.getEmployeeId();
    this.managerRepositoryService = vacationManagerRepositoryService;
    this.ManagerDataService = ManagerDataService;
    this.year = new Date().getFullYear();
  }

  initMainData() {
    return this.managerRepositoryService.getManager(this.managerId, this.year)
      .then((manager) => {
        this.ManagerDataService.setManager(manager);
        return manager;
      });
  }
}

export default InitialDataManagerService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/initialData/initialDataManager.service.js